module.exports = __webpack_public_path__ + "media/images/case-studies/jonai-49f91367030b7cc72a2c1f27b5622a53.png";